__turbopack_context__.v({
  "accordionIcon": "Tabs-module-scss-module__tBY5Ia__accordionIcon",
  "accordionIconActive": "Tabs-module-scss-module__tBY5Ia__accordionIconActive",
  "fade-in": "Tabs-module-scss-module__tBY5Ia__fade-in",
  "label": "Tabs-module-scss-module__tBY5Ia__label",
  "labelCount": "Tabs-module-scss-module__tBY5Ia__labelCount",
  "labelText": "Tabs-module-scss-module__tBY5Ia__labelText",
  "no-transform": "Tabs-module-scss-module__tBY5Ia__no-transform",
  "rotate": "Tabs-module-scss-module__tBY5Ia__rotate",
  "tab": "Tabs-module-scss-module__tBY5Ia__tab",
  "tabActive": "Tabs-module-scss-module__tBY5Ia__tabActive",
  "tabList": "Tabs-module-scss-module__tBY5Ia__tabList",
  "tabListScrollButton": "Tabs-module-scss-module__tBY5Ia__tabListScrollButton",
  "tabListScrollButtonLeft": "Tabs-module-scss-module__tBY5Ia__tabListScrollButtonLeft" + " " + "Tabs-module-scss-module__tBY5Ia__tabListScrollButton",
  "tabListScrollButtonRight": "Tabs-module-scss-module__tBY5Ia__tabListScrollButtonRight" + " " + "Tabs-module-scss-module__tBY5Ia__tabListScrollButton",
  "tabListWrapper": "Tabs-module-scss-module__tBY5Ia__tabListWrapper",
  "tabPanel": "Tabs-module-scss-module__tBY5Ia__tabPanel",
  "tabPanelActive": "Tabs-module-scss-module__tBY5Ia__tabPanelActive",
  "tabs": "Tabs-module-scss-module__tBY5Ia__tabs",
  "wrapper": "Tabs-module-scss-module__tBY5Ia__wrapper",
  "wrapperOverflowPaddingLtMd": "Tabs-module-scss-module__tBY5Ia__wrapperOverflowPaddingLtMd",
  "wrapperResponsive": "Tabs-module-scss-module__tBY5Ia__wrapperResponsive",
});
